export type ThemeSignalColor = 'info' | 'success' | 'warning' | 'danger';
export const SignalNames: ThemeSignalColor[] = ['info', 'success', 'warning', 'danger'];

export type ThemeColors
  = | 'primary'
    | 'brand'
    | 'secondary'
    | 'grey'
    | 'dark-grey'
    | 'sand'
    | 'black'
    | 'white'
    | ThemeSignalColor;

export type ThemeColorMiniPalette = {
  black: string;
  white: string;
};

export type ThemeColorPalette = {
  'main': string;
  'dark': string;
  'ultra-dark': string;
  'contrast': string;
  'light': string;
  'ultra-light': string;
};

export type ThemeColorsPaletteTonalities
  = `${string & ThemeColors}.${string & keyof ThemeColorPalette}`;

export type ThemeColorsTonalities
  = | ThemeColorsPaletteTonalities
    | `mono.${string & keyof ThemeColorMiniPalette}`;

export type ThemeColorsValues = ThemeColors | ThemeColorsTonalities;

export type ThemeElevationValues = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const themeElevations: ThemeElevationValues[] = ['sm', 'md', 'lg', 'xl', 'xxl'];
